module.exports = __webpack_public_path__ + "static/fujitsu-logo-46afe04939ea710424f2df686566ce2a.png";